import React, { useEffect, useState } from 'react'

import Page from "../../components/Page"
import Loader from '../../components/Loader/Loader';
import CourseCategoryListingSection from '../../components/Course/CourseCategoryListingSection';
import MenuCoaching from '../../components/MenuCoaching';
import CourseListingPage from '../courses/CourseListingPage';

const ProviderCourseCategories = (props) => {

  const [isLoading, setIsLoading] = useState(true);
 console.log("props1",props);
//  let isLoading = false;
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const providerId = params.get('provider_id');
  

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      {/* <Page>
      <MenuCoaching providerId={providerId} selectedItem={1}/> */}
        {/* <CourseCategoryListingSection 
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        /> */}
        <CourseListingPage  isLoading={isLoading}
          setIsLoading={setIsLoading}/>
      {/* </Page> */}
    </>
  )
}

export default ProviderCourseCategories